import type { SVGProps } from 'react';

const ValidationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <path
      d="M21.4847 50.1001H11.1113C5.58848 50.1001 1.11133 45.623 1.11133 40.1001V39.4262V10.8813V10.8813C1.11133 6.09928 4.98796 2.22266 9.77002 2.22266H43.0635C48.5863 2.22266 53.0635 6.69981 53.0635 12.2227V26.6707"
      stroke="#112A55"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.4621 28.7062H14.2793C12.0702 28.7062 10.2793 26.9154 10.2793 24.7062V22.5195C10.2793 20.3104 12.0702 18.5195 14.2793 18.5195H39.8954C42.1045 18.5195 43.8954 20.3104 43.8954 22.5195V23.7212"
      stroke="#112A55"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.11133 10.8789H53.0635"
      stroke="#112A55"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.26074 35.8359H21.4848"
      stroke="#112A55"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.26074 42.9688H21.4848"
      stroke="#112A55"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.1687 57.7789C52.1967 57.7789 58.7047 51.2709 58.7047 43.243C58.7047 35.215 52.1967 28.707 44.1687 28.707C36.1408 28.707 29.6328 35.215 29.6328 43.243C29.6328 51.2709 36.1408 57.7789 44.1687 57.7789Z"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.9199 43.625L40.1101 46.0889C41.2969 47.4241 43.3832 47.4241 44.57 46.0889L51.1803 38.6523"
      stroke="#2563EB"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ValidationIcon;
